import FlooringVariationFiltersForm from "./flooring-variation-filters-form";

export default FlooringVariationFiltersForm;
